import React, { useEffect, useState } from 'react';
import styles from './WheelModal.module.scss';
import Modal from './Modal/Modal';
import { TelegramSticker } from '@/components/TelegramSticker';
import WebApp from '@twa-dev/sdk';

interface WheelModalProps {
  open: boolean;
  onClose: () => void;
}

const WheelModal: React.FC<WheelModalProps> = ({ open, onClose }) => {
  if (!open) return null;

  const handleParticipate = async () => {
    // Добавляем вибрацию при нажатии на кнопку
    if (WebApp && WebApp.HapticFeedback) {
      WebApp.HapticFeedback.notificationOccurred('success');
    } else {
      console.warn('Telegram WebApp or HapticFeedback is not available');
    }
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div>
        <h2 className={styles.title}>
          <span>Этот раздел</span> <br />
          скоро станет доступен!
        </h2>
        <div className={styles.stickerWrapper}>
          <TelegramSticker
            tgsUrl="./Chest.tgs"
            style={{ width: 180, height: 180 }}
            loop={false}
            autoplay={true}
          />
        </div>

        <button className={styles.withdrawButton} onClick={handleParticipate}>
          Понятно
        </button>
      </div>
    </Modal>
  );
};

export default WheelModal;
